export interface FilterOptionLike {
  id: string;
  name: string;
  displayName?: string;
  count: number;
}

/**
 * Derive unique marketplaces from sessions with counts.
 * One function per file (single method per file).
 */
export function deriveMarketplacesFromSessions(
  sessions: Array<{
    marketplace?: string | null;
    needReviewFields?: number | null;
  }>,
): FilterOptionLike[] {
  const byId = new Map<string, { id: string; name: string; count: number }>();
  for (const s of sessions) {
    const id = s.marketplace?.toLowerCase().replace(/\s+/g, "-") || "unknown";
    const count = s.needReviewFields ?? 0;
    const existing = byId.get(id);
    if (existing) existing.count += count;
    else
      byId.set(id, {
        id,
        name: s.marketplace?.toUpperCase() || id.toUpperCase(),
        count,
      });
  }
  return Array.from(byId.values());
}
